import { Suspense } from "react";
import { Spinner } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { useClaims } from "../../hooks/ClaimsHooks";
import classNames from "classnames";
import { transformHtml } from "../../utils/CmsUtils";
import { claimsTypePageUrl } from "../../config/urls";
import "./style.scss";
import CockpitEditLink from "../CockpitEditLink";

const ClaimTypeList = ({
  claimTypes = [],
  compact = false,
  wholesale = false
}) => {
  const groupedClaimTypes = claimTypes.reduce((res, ct) => {
    if (res[ct.group] === undefined) res[ct.group] = [];
    res[ct.group].push({ ...ct });
    return res;
  }, {});
  return (
    <div className={classNames("claim-type-list", { compact: compact })}>
      {Object.entries(groupedClaimTypes).map(([group, items]) => (
        <div className="claim-type-group" key={group}>
          <h3>{group}</h3>
          {!compact ? (
            items.map(item => (
              <div
                key={item.id}
                className={classNames("claim-type-item", { compact: compact })}
              >
                <Link to={claimsTypePageUrl(item, wholesale)}>
                  <h4 className="claim-type-heading">{item.title}</h4>
                  <div className="claim-type-descr">
                    {transformHtml(item.description)}
                  </div>
                </Link>
              </div>
            ))
          ) : (
            <ul>
              {items.map(item => (
                <li key={item.id}>
                  <Link to={claimsTypePageUrl(item, wholesale)}>
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export const ClaimTypeListWithQuery = ({ compact = false }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const claims = useClaims();
  return (
    <ClaimTypeList
      claimTypes={claims.types}
      compact={compact}
      wholesale={params.get("wholesale") !== null}
    />
  );
};

export const CockpitClaimTypeList = ({ compact = false }) => {
  return (
    <Suspense fallback={<Spinner />}>
      <ClaimTypeListWithQuery compact={compact} />
      <CockpitEditLink
        collection={"claim_types"}
        labelKey={"edit.claim_types"}
      />
    </Suspense>
  );
};

export default ClaimTypeList;
